'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp;
// import { Helper } from 'helpers/support';
// import { RANK } from 'helpers/Constant';
// import { Link } from 'react-router';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _Constant = require('helpers/Constant');

var _Constant2 = _interopRequireDefault(_Constant);

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _blackPlus3x = require('assets/img/payment/blackPlus@3x.png');

var _blackPlus3x2 = _interopRequireDefault(_blackPlus3x);

var _reactRedux = require('react-redux');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var data = [{ title: 'Ví Lookme', money: '102.000' }, { title: 'Visa' }, { title: 'Visa' }, { title: 'Visa' }, { title: 'Visa' }, { title: 'Visa' }, { title: 'Visa' }, { title: 'Visa' }, { title: 'Visa' }, { title: 'Visa' }, { title: 'Visa' }, { title: 'Visa' }, { title: 'Visa' }];
var PaymentList = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user
  };
}, (0, _extends3.default)({}, authActions)), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PaymentList, _Component);

  function PaymentList(props) {
    (0, _classCallCheck3.default)(this, PaymentList);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PaymentList.__proto__ || (0, _getPrototypeOf2.default)(PaymentList)).call(this, props));

    _this.onErrorImage = function (event) {
      event.target.onerror = null;
      event.target.src = '/error-img.svg';
    };

    _this.onChoose = function (item) {
      data.forEach(function (i) {
        return i.isSelected = false;
      });
      item.isSelected = true;
      _this.setState({ reload: true });
    };

    _this.renderListItem = function (dataItem) {
      return dataItem.map(function (item) {
        return _react2.default.createElement(
          'div',
          { onClick: function onClick() {
              return _this.onChoose(item);
            } },
          _react2.default.createElement(_components.CardItem, {
            title: item.title,
            leftArrow: item.money && item.money + '\u0111',
            selected: item.isSelected
          })
        );
      });
    };

    _this.state = {
      reload: false
    };
    return _this;
  }

  (0, _createClass3.default)(PaymentList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      data.forEach(function (item) {
        return item.isSelected = false;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var user = this.props.user;

      var botInfo = null;
      if (user && user.rank) {
        botInfo = _Constant2.default.RANK[user.rank];
        botInfo.pointReward = user.rewardPoints;
      }
      var styles = require('./PaymentList.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.container },
        _react2.default.createElement(
          'div',
          { className: styles.contentView },
          this.renderListItem(data)
        ),
        _react2.default.createElement(
          'div',
          { className: styles.addCardView },
          _react2.default.createElement('img', { src: _blackPlus3x2.default, className: styles.img }),
          _react2.default.createElement(
            'div',
            { className: styles.title },
            'Th\xEAm th\u1EBB m\u1EDBi'
          )
        ),
        botInfo && _react2.default.createElement(_components.BottomInfoUser, { data: botInfo })
      );
    }
  }]);
  return PaymentList;
}(_react.Component), _class2.propTypes = {
  user: _react.PropTypes.object
}, _temp)) || _class);
exports.default = PaymentList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Payment/PaymentList.js
// module id = 1620
// module chunks = 0